import { Button } from '@civilgrid/ui/components';
import { Link, useNavigate } from '@tanstack/react-router';
import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import Table from '~/components2/Table';
import store from '../../store';
import { columns } from './columns';

export default function Contacts() {
  const navigate = useNavigate();
  const { contacts, agency } = useSnapshot(store) as typeof store;

  const data = useMemo(() => Object.values(contacts), [contacts]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    enableSorting: true,
    enableColumnResizing: true,
    columnResizeMode: 'onChange',
    initialState: {
      sorting: [{ id: 'lastName', desc: false }],
    },
  });

  return (
    <div className="grow space-y-2 overflow-y-auto">
      <Link to="/admin/civil-search/agencies/$agencyId/$tab" params={{ agencyId: agency!.id, tab: 'new-contact' }}>
        <Button>Add New Contact</Button>
      </Link>
      <Table
        id="cs-contacts-v1"
        table={table}
        onRowClick={(row) => {
          navigate({
            to: `/admin/civil-search/agencies/${agency!.id}/contacts?contactId=${row.original.id}`,
          });
        }}
      />
    </div>
  );
}
